<script>
	import { createEventDispatcher } from 'svelte';
	import Icon from '../icons/Icon.svelte';

	const dispatch = createEventDispatcher();

	export let show = false;
	export let aiImportStep = 1;
	export let aiErrorMessage = '';
	export let aiFileBase64 = '';
	export let aiFilePreview = '';
	export let aiFileName = '';
	export let aiExtractedData = { totalCategories: 0, totalProducts: 0, categories: [] };
	export let complementGroups = [];
	export let isSavingAiMenu = false;

	function handleClose() {
		dispatch('close');
	}

	function handleAiDrop(e) {
		dispatch('aiDrop', e);
	}

	function handleAiFileSelect(e) {
		dispatch('aiFileSelect', e);
	}

	function handleChangeFile() {
		dispatch('changeFile');
	}

	function handleProcessAiImport() {
		dispatch('processAiImport');
	}

	function handleRemoveCategory(catIdx) {
		dispatch('removeCategory', catIdx);
	}

	function handleRemoveProduct(catIdx, prodIdx) {
		dispatch('removeProduct', { catIdx, prodIdx });
	}

	function handleToggleCatComplementGroup(cat, groupId) {
		dispatch('toggleCatComplementGroup', { cat, groupId });
	}

	function handleConfirmAndSave() {
		dispatch('confirmAndSave');
	}

	function handleBackToStep1() {
		dispatch('backToStep1');
	}
</script>

{#if show}
	<div class="modal-backdrop-ai" on:click|self={handleClose}>
		<div class="modal-card-ai {aiImportStep === 3 ? 'wide' : ''}">
			<!-- Cabeçalho do Modal -->
			<div class="modal-header-ai">
				<div class="header-icon-ai">
					<Icon name="sparkles" size={22} color="#4F46E5" />
				</div>
				<div class="header-titles-ai">
					<h3>Digitalizar Cardápio com Inteligência Artificial</h3>
					<p>Tire uma foto do cardápio físico ou envie um arquivo PDF da gráfica</p>
				</div>
				<button type="button" class="modal-close-ai" on:click={handleClose} title="Fechar" aria-label="Fechar">
					<Icon name="x" size={18} />
				</button>
			</div>

			<!-- PASSO 1: UPLOAD DO ARQUIVO -->
			{#if aiImportStep === 1}
				<div class="modal-body-ai">
					{#if aiErrorMessage}
						<div class="ai-error-alert">
							<Icon name="alert-triangle" size={18} color="#EF4444" />
							<span>{aiErrorMessage}</span>
						</div>
					{/if}

					<div 
						class="dropzone-ai {aiFileBase64 ? 'has-file' : ''}" 
						on:dragover|preventDefault
						on:drop={handleAiDrop}
					>
						{#if !aiFileBase64}
							<div class="dropzone-content">
								<div class="dropzone-icon">
									<svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="#6366F1" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
										<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
										<polyline points="17 8 12 3 7 8"></polyline>
										<line x1="12" y1="3" x2="12" y2="15"></line>
									</svg>
								</div>
								<h4>Arraste a foto ou PDF do seu cardápio aqui</h4>
								<p>Formatos suportados: <strong>JPG, PNG, WEBP ou PDF</strong> (até 25MB)</p>
								
								<label class="btn-browse-file">
									<span>Selecionar do Computador</span>
									<input 
										type="file" 
										accept="image/*,application/pdf" 
										on:change={handleAiFileSelect}
										style="display: none;" 
									/>
								</label>
							</div>
						{:else}
							<div class="file-preview-box">
								{#if aiFilePreview}
									<img src={aiFilePreview} alt="Cardápio" class="preview-thumb" />
								{:else}
									<div class="pdf-icon-box">
										<Icon name="file-text" size={22} color="#4F46E5" />
										<span>PDF</span>
									</div>
								{/if}
								<div class="file-info-col">
									<span class="file-name-tag">{aiFileName}</span>
									<span class="file-status-tag">
										<Icon name="check" size={14} color="#059669" />
										<span>Arquivo carregado e pronto para leitura</span>
									</span>
									<button type="button" class="btn-change-file" on:click={handleChangeFile}>
										Trocar arquivo
									</button>
								</div>
							</div>
						{/if}
					</div>

					<div class="ai-tips-card">
						<div class="tips-title-wrap">
							<Icon name="lightbulb" size={16} color="#D97706" />
							<span class="tips-title">Dicas para 100% de precisão:</span>
						</div>
						<ul>
							<li>Certifique-se de que os preços e nomes dos lanches estejam legíveis.</li>
							<li>Se for foto de celular, tire de cima, reta e em ambiente bem iluminado.</li>
							<li>PDFs vetoriais de gráfica são lidos quase instantaneamente.</li>
						</ul>
					</div>
				</div>

				<div class="modal-footer-ai">
					<button type="button" class="btn-ai-cancel" on:click={handleClose}>
						Cancelar
					</button>
					<button 
						type="button" 
						class="btn-ai-process" 
						disabled={!aiFileBase64}
						on:click={handleProcessAiImport}
					>
						<Icon name="sparkles" size={16} color="#FFFFFF" />
						<span>Ler Cardápio com IA</span>
					</button>
				</div>

			<!-- PASSO 2: PROCESSANDO COM IA -->
			{:else if aiImportStep === 2}
				<div class="modal-body-ai loading-state">
					<div class="ai-scanner-animation">
						<div class="scanner-circle"></div>
						<svg class="scanner-svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#6366F1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
							<circle cx="11" cy="11" r="8"></circle>
							<line x1="21" y1="21" x2="16.65" y2="16.65"></line>
						</svg>
					</div>
					<h3>A Inteligência Artificial está lendo o seu cardápio...</h3>
					<p class="loading-subtext">Identificando categorias, ingredientes, lanches e preços.</p>
					<div class="loading-bar-wrapper">
						<div class="loading-bar-fill"></div>
					</div>
					<span class="time-estimate">Geralmente leva entre 3 e 8 segundos</span>
				</div>

			<!-- PASSO 3: REVISÃO E CONFIRMAÇÃO DOS PRODUTOS -->
			{:else if aiImportStep === 3}
				<div class="modal-body-ai review-state">
					<div class="review-summary-banner">
						<div class="summary-left">
							<div class="sparkle-tag">
								<Icon name="sparkles" size={13} color="#4F46E5" />
								<span>Leitura Concluída</span>
							</div>
							<h4>Encontramos {aiExtractedData.totalCategories} Categorias e {aiExtractedData.totalProducts} Produtos!</h4>
							<p>Revise os itens abaixo. Você pode editar os nomes e preços ou remover o que não quiser antes de salvar.</p>
						</div>
					</div>

					<div class="review-categories-list">
						{#each aiExtractedData.categories as cat, catIdx}
							<div class="review-category-card">
								<div class="review-cat-header">
									<div class="cat-title-edit">
										<span class="cat-icon-badge">
											<Icon name="utensils" size={15} color="#4F46E5" />
										</span>
										<input type="text" class="input-cat-name" bind:value={cat.name} placeholder="Nome da Categoria" />
										<span class="cat-count-badge">{cat.products.length} {cat.products.length === 1 ? 'item' : 'itens'}</span>
									</div>
									<button 
										type="button" 
										class="btn-remove-cat" 
										on:click={() => handleRemoveCategory(catIdx)}
										title="Remover categoria inteira"
									>
										<Icon name="trash" size={13} color="#EF4444" />
										<span>Remover Categoria</span>
									</button>
								</div>

								<!-- Barra de Seleção de Complementos da Categoria -->
								<div class="review-cat-complements-bar">
									<div class="complements-bar-left">
										<Icon name="layers" size={14} color="#4F46E5" />
										<span class="bar-title">Vincular Complementos:</span>
										<span class="bar-sub">(Aplica a todos os itens desta categoria)</span>
									</div>
									{#if complementGroups.length === 0}
										<span class="complements-empty-hint">Nenhum grupo global cadastrado ainda. Use a aba "Complementos Globais" para criar.</span>
									{:else}
										<div class="cat-complements-chips">
											{#each complementGroups as g (g.id)}
												{@const isSelected = (cat.complementGroupIds || []).includes(g.id)}
												<button
													type="button"
													class="complement-chip-toggle {isSelected ? 'selected' : ''}"
													on:click={() => handleToggleCatComplementGroup(cat, g.id)}
													title={isSelected ? 'Clique para desvincular' : 'Clique para vincular este grupo'}
												>
													<span class="chip-check">{isSelected ? '✓' : '+'}</span>
													<span class="chip-name">{g.name}</span>
													<span class="chip-count">({g.items?.length || 0})</span>
												</button>
											{/each}
										</div>
									{/if}
								</div>

								<div class="review-products-table">
									{#each cat.products as prod, prodIdx}
										<div class="review-product-row {prod.pizza_sizes && prod.pizza_sizes.enabled ? 'has-sizes' : ''}">
											<div class="prod-col-name">
												<input type="text" class="input-prod-name" bind:value={prod.name} placeholder="Nome do produto" />
												<input type="text" class="input-prod-desc" bind:value={prod.description} placeholder="Descrição / Ingredientes (opcional)" />
											</div>

											{#if prod.pizza_sizes && prod.pizza_sizes.enabled}
												<div class="prod-col-pizza-sizes">
													<div class="size-input-box">
														<span class="size-tag broto">🍕 Broto</span>
														<span class="currency-prefix">R$</span>
														<input 
															type="number" 
															step="0.01" 
															min="0" 
															class="input-prod-price size-field" 
															bind:value={prod.pizza_sizes.broto_price}
															on:input={() => { prod.price = prod.pizza_sizes.broto_price; }}
															placeholder="Broto"
														/>
													</div>
													<div class="size-input-box">
														<span class="size-tag grande">🍕 Grande</span>
														<span class="currency-prefix">R$</span>
														<input 
															type="number" 
															step="0.01" 
															min="0" 
															class="input-prod-price size-field" 
															bind:value={prod.pizza_sizes.grande_price}
															placeholder="Grande"
														/>
													</div>
													<button 
														type="button" 
														class="btn-toggle-sizes active" 
														title="Alternar para preço único"
														on:click={() => { prod.pizza_sizes.enabled = false; }}
													>
														Broto & Grande ✓
													</button>
												</div>
											{:else}
												<div class="prod-col-price">
													<span class="currency-prefix">R$</span>
													<input type="number" step="0.01" min="0" class="input-prod-price" bind:value={prod.price} />
													{#if /pizza/i.test(cat.name || '') || /pizza/i.test(prod.name || '')}
														<button 
															type="button" 
															class="btn-toggle-sizes" 
															title="Ativar tamanhos Broto e Grande"
															on:click={() => {
																prod.pizza_sizes = {
																	enabled: true,
																	broto_price: prod.price || 0,
																	grande_price: prod.price ? Number((prod.price * 1.3).toFixed(2)) : 0
																};
															}}
														>
															+ Broto/Grande
														</button>
													{/if}
												</div>
											{/if}

											<button 
												type="button" 
												class="btn-del-prod" 
												on:click={() => handleRemoveProduct(catIdx, prodIdx)}
												title="Remover produto"
												aria-label="Remover produto"
											>
												<Icon name="trash" size={14} color="#EF4444" />
											</button>
										</div>
									{/each}
								</div>
							</div>
						{/each}
					</div>
				</div>

				<div class="modal-footer-ai">
					<button type="button" class="btn-ai-cancel" on:click={handleBackToStep1} disabled={isSavingAiMenu}>
						<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
							<line x1="19" y1="12" x2="5" y2="12"></line>
							<polyline points="12 19 5 12 12 5"></polyline>
						</svg>
						<span>Voltar</span>
					</button>
					<button 
						type="button" 
						class="btn-ai-save-all" 
						disabled={isSavingAiMenu || aiExtractedData.totalProducts === 0}
						on:click={handleConfirmAndSave}
					>
						{#if isSavingAiMenu}
							<span class="spin-icon">⏳</span>
							<span>Salvando no Cardápio...</span>
						{:else}
							<Icon name="check" size={16} color="#FFFFFF" />
							<span>Confirmar e Cadastrar {aiExtractedData.totalProducts} {aiExtractedData.totalProducts === 1 ? 'Produto' : 'Produtos'}</span>
						{/if}
					</button>
				</div>
			{/if}
		</div>
	</div>
{/if}

<style>
	.modal-backdrop-ai {
		position: fixed;
		inset: 0;
		background: rgba(15, 23, 42, 0.6);
		backdrop-filter: blur(4px);
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 1200;
		padding: 20px;
	}

	.modal-card-ai {
		width: 620px;
		max-width: 100%;
		max-height: 90vh;
		background: #FFFFFF;
		border-radius: 16px;
		box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
		display: flex;
		flex-direction: column;
		overflow: hidden;
		animation: modalPop 0.18s cubic-bezier(0.16, 1, 0.3, 1);
	}

	@keyframes modalPop {
		from { opacity: 0; transform: scale(0.96) translateY(8px); }
		to { opacity: 1; transform: scale(1) translateY(0); }
	}

	.modal-card-ai.wide {
		width: 860px;
	}

	.modal-header-ai {
		display: flex;
		align-items: center;
		gap: 14px;
		padding: 20px 24px;
		border-bottom: 1px solid #E2E8F0;
	}

	.header-icon-ai {
		width: 42px;
		height: 42px;
		border-radius: 10px;
		background: #EEF2FF;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
	}

	.header-titles-ai {
		flex: 1;
	}

	.header-titles-ai h3 {
		margin: 0;
		font-size: 16px;
		font-weight: 800;
		color: #0F172A;
	}

	.header-titles-ai p {
		margin: 2px 0 0 0;
		font-size: 12px;
		color: #64748B;
	}

	.modal-close-ai {
		background: transparent;
		border: none;
		color: #94A3B8;
		cursor: pointer;
		padding: 6px;
		border-radius: 6px;
		transition: all 0.15s ease;
	}

	.modal-close-ai:hover {
		background: #F1F5F9;
		color: #0F172A;
	}

	.modal-body-ai {
		padding: 24px;
		overflow-y: auto;
		display: flex;
		flex-direction: column;
		gap: 16px;
	}

	.ai-error-alert {
		padding: 12px 14px;
		background: #FEF2F2;
		border: 1px solid #FECACA;
		border-radius: 8px;
		font-size: 13px;
		color: #DC2626;
		display: flex;
		align-items: center;
		gap: 8px;
	}

	.dropzone-ai {
		padding: 36px 20px;
		border: 2px dashed #CBD5E1;
		border-radius: 12px;
		text-align: center;
		background: #F8FAFC;
		transition: all 0.15s ease;
	}

	.dropzone-ai.has-file {
		border-color: #6366F1;
		background: #EEF2FF;
	}

	.dropzone-content {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 8px;
	}

	.dropzone-content h4 {
		margin: 0;
		font-size: 15px;
		font-weight: 700;
		color: #0F172A;
	}

	.dropzone-content p {
		margin: 0 0 10px 0;
		font-size: 12px;
		color: #64748B;
	}

	.btn-browse-file {
		display: inline-flex;
		padding: 10px 20px;
		background: #4F46E5;
		color: #FFFFFF;
		font-size: 13px;
		font-weight: 700;
		border-radius: 8px;
		cursor: pointer;
		transition: all 0.15s ease;
	}

	.btn-browse-file:hover {
		background: #4338CA;
	}

	.file-preview-box {
		display: flex;
		align-items: center;
		gap: 16px;
		padding: 12px;
		background: #FFFFFF;
		border: 1px solid #CBD5E1;
		border-radius: 10px;
		text-align: left;
	}

	.preview-thumb {
		width: 64px;
		height: 64px;
		object-fit: cover;
		border-radius: 8px;
	}

	.pdf-icon-box {
		width: 64px;
		height: 64px;
		border-radius: 8px;
		background: #EEF2FF;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 4px;
	}

	.pdf-icon-box span {
		font-size: 10px;
		font-weight: 800;
		color: #4F46E5;
	}

	.file-info-col {
		flex: 1;
		display: flex;
		flex-direction: column;
		gap: 4px;
	}

	.file-name-tag {
		font-size: 13px;
		font-weight: 700;
		color: #0F172A;
		word-break: break-all;
	}

	.file-status-tag {
		display: flex;
		align-items: center;
		gap: 6px;
		font-size: 12px;
		color: #059669;
		font-weight: 600;
	}

	.btn-change-file {
		align-self: flex-start;
		background: transparent;
		border: none;
		color: #6366F1;
		font-size: 11px;
		font-weight: 700;
		cursor: pointer;
		padding: 0;
		margin-top: 4px;
	}

	.btn-change-file:hover {
		text-decoration: underline;
	}

	.ai-tips-card {
		padding: 14px 16px;
		background: #FFFBEB;
		border: 1px solid #FDE68A;
		border-radius: 10px;
	}

	.tips-title-wrap {
		display: flex;
		align-items: center;
		gap: 6px;
		margin-bottom: 6px;
	}

	.tips-title {
		font-size: 12px;
		font-weight: 700;
		color: #B45309;
	}

	.ai-tips-card ul {
		margin: 0;
		padding-left: 20px;
		font-size: 11px;
		color: #92400E;
		line-height: 1.5;
	}

	.modal-footer-ai {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		gap: 10px;
		padding: 16px 24px;
		border-top: 1px solid #E2E8F0;
		background: #F8FAFC;
	}

	.btn-ai-cancel {
		display: flex;
		align-items: center;
		gap: 6px;
		padding: 9px 18px;
		background: #FFFFFF;
		border: 1px solid #CBD5E1;
		color: #475569;
		font-size: 13px;
		font-weight: 600;
		border-radius: 8px;
		cursor: pointer;
		transition: all 0.15s ease;
	}

	.btn-ai-cancel:hover:not(:disabled) {
		background: #F1F5F9;
		color: #0F172A;
	}

	.btn-ai-process {
		display: flex;
		align-items: center;
		gap: 8px;
		padding: 9px 20px;
		background: #4F46E5;
		color: #FFFFFF;
		font-size: 13px;
		font-weight: 700;
		border: none;
		border-radius: 8px;
		cursor: pointer;
		transition: all 0.15s ease;
	}

	.btn-ai-process:hover:not(:disabled) {
		background: #4338CA;
	}

	.btn-ai-process:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}

	.btn-ai-save-all {
		display: flex;
		align-items: center;
		gap: 8px;
		padding: 10px 22px;
		background: #059669;
		color: #FFFFFF;
		font-size: 13px;
		font-weight: 700;
		border: none;
		border-radius: 8px;
		cursor: pointer;
		transition: all 0.15s ease;
	}

	.btn-ai-save-all:hover:not(:disabled) {
		background: #047857;
	}

	.btn-ai-save-all:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}

	/* Scanner Loading */
	.loading-state {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 40px 20px;
		text-align: center;
	}

	.ai-scanner-animation {
		position: relative;
		width: 70px;
		height: 70px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 16px;
	}

	.scanner-circle {
		position: absolute;
		inset: 0;
		border-radius: 50%;
		border: 3px solid #EEF2FF;
		border-top-color: #6366F1;
		animation: spin 1s linear infinite;
	}

	@keyframes spin {
		from { transform: rotate(0deg); }
		to { transform: rotate(360deg); }
	}

	.loading-subtext {
		font-size: 13px;
		color: #64748B;
		margin: 4px 0 16px 0;
	}

	.loading-bar-wrapper {
		width: 260px;
		height: 6px;
		background: #E2E8F0;
		border-radius: 4px;
		overflow: hidden;
		margin-bottom: 8px;
	}

	.loading-bar-fill {
		width: 60%;
		height: 100%;
		background: #4F46E5;
		animation: loadingPulse 1.5s ease-in-out infinite;
	}

	@keyframes loadingPulse {
		0% { transform: translateX(-100%); }
		100% { transform: translateX(200%); }
	}

	.time-estimate {
		font-size: 11px;
		color: #94A3B8;
	}

	/* Review State */
	.review-summary-banner {
		padding: 14px 18px;
		background: #EEF2FF;
		border: 1px solid #E0E7FF;
		border-radius: 10px;
	}

	.sparkle-tag {
		display: inline-flex;
		align-items: center;
		gap: 5px;
		font-size: 11px;
		font-weight: 700;
		color: #4F46E5;
		text-transform: uppercase;
		margin-bottom: 4px;
	}

	.review-summary-banner h4 {
		margin: 0;
		font-size: 15px;
		font-weight: 800;
		color: #0F172A;
	}

	.review-summary-banner p {
		margin: 4px 0 0 0;
		font-size: 12px;
		color: #475569;
	}

	.review-categories-list {
		display: flex;
		flex-direction: column;
		gap: 14px;
	}

	.review-category-card {
		border: 1px solid #CBD5E1;
		border-radius: 10px;
		overflow: hidden;
	}

	.review-cat-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 10px 14px;
		background: #F8FAFC;
		border-bottom: 1px solid #E2E8F0;
	}

	.cat-title-edit {
		display: flex;
		align-items: center;
		gap: 8px;
		flex: 1;
	}

	.cat-icon-badge {
		width: 28px;
		height: 28px;
		border-radius: 6px;
		background: #EEF2FF;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
	}

	.input-cat-name {
		font-size: 14px;
		font-weight: 700;
		color: #0F172A;
		border: 1px solid transparent;
		background: transparent;
		padding: 4px 8px;
		border-radius: 6px;
	}

	.input-cat-name:focus {
		outline: none;
		background: #FFFFFF;
		border-color: #6366F1;
	}

	.cat-count-badge {
		font-size: 11px;
		background: #E2E8F0;
		padding: 2px 6px;
		border-radius: 8px;
		color: #475569;
	}

	.btn-remove-cat {
		display: flex;
		align-items: center;
		gap: 4px;
		background: transparent;
		border: none;
		color: #EF4444;
		font-size: 11px;
		font-weight: 600;
		cursor: pointer;
	}

	/* Barra de Seleção de Complementos da Categoria */
	.review-cat-complements-bar {
		display: flex;
		flex-direction: column;
		gap: 8px;
		padding: 10px 16px;
		background: #F8FAFC;
		border-top: 1px solid #E2E8F0;
		border-bottom: 1px solid #E2E8F0;
	}

	.complements-bar-left {
		display: flex;
		align-items: center;
		gap: 6px;
		font-size: 12px;
	}

	.complements-bar-left .bar-title {
		font-weight: 700;
		color: #1E293B;
	}

	.complements-bar-left .bar-sub {
		font-size: 11px;
		color: #64748B;
	}

	.complements-empty-hint {
		font-size: 11px;
		color: #94A3B8;
		font-style: italic;
	}

	.cat-complements-chips {
		display: flex;
		flex-wrap: wrap;
		gap: 6px;
	}

	.complement-chip-toggle {
		display: inline-flex;
		align-items: center;
		gap: 5px;
		padding: 4px 10px;
		background: #FFFFFF;
		border: 1px solid #CBD5E1;
		border-radius: 999px;
		font-size: 12px;
		color: #334155;
		cursor: pointer;
		transition: all 0.15s ease;
	}

	.complement-chip-toggle:hover {
		border-color: #6366F1;
		color: #4F46E5;
		background: #F5F3FF;
	}

	.complement-chip-toggle.selected {
		background: #4F46E5;
		border-color: #4338CA;
		color: #FFFFFF;
		font-weight: 600;
		box-shadow: 0 1px 3px rgba(79, 70, 229, 0.25);
	}

	.complement-chip-toggle .chip-check {
		font-weight: 800;
		font-size: 12px;
	}

	.complement-chip-toggle .chip-count {
		opacity: 0.75;
		font-size: 10px;
	}

	.review-products-table {
		display: flex;
		flex-direction: column;
	}

	.review-product-row {
		display: flex;
		align-items: center;
		gap: 12px;
		padding: 8px 14px;
		border-bottom: 1px solid #F1F5F9;
	}

	.review-product-row:last-child {
		border-bottom: none;
	}

	.prod-col-name {
		flex: 1;
		display: flex;
		flex-direction: column;
		gap: 4px;
	}

	.input-prod-name {
		font-size: 13px;
		font-weight: 700;
		color: #0F172A;
		border: 1px solid #CBD5E1;
		border-radius: 6px;
		padding: 5px 8px;
	}

	.input-prod-desc {
		font-size: 11px;
		color: #64748B;
		border: 1px solid #E2E8F0;
		border-radius: 6px;
		padding: 4px 8px;
	}

	.prod-col-price {
		display: flex;
		align-items: center;
		gap: 4px;
	}

	.currency-prefix {
		font-size: 12px;
		font-weight: 700;
		color: #64748B;
	}

	.input-prod-price {
		width: 80px;
		font-size: 13px;
		font-weight: 700;
		color: #0F172A;
		border: 1px solid #CBD5E1;
		border-radius: 6px;
		padding: 5px 8px;
	}

	.btn-del-prod {
		background: transparent;
		border: none;
		cursor: pointer;
		color: #EF4444;
		padding: 4px;
	}

	.prod-col-pizza-sizes {
		display: flex;
		align-items: center;
		gap: 8px;
		flex-wrap: wrap;
	}

	.size-input-box {
		display: flex;
		align-items: center;
		gap: 4px;
		background: #F8FAFC;
		padding: 2px 6px;
		border-radius: 6px;
		border: 1px solid #E2E8F0;
	}

	.size-tag {
		font-size: 10px;
		font-weight: 800;
		text-transform: uppercase;
		border-radius: 4px;
		padding: 2px 5px;
		white-space: nowrap;
	}

	.size-tag.broto {
		background: #FEF3C7;
		color: #92400E;
	}

	.size-tag.grande {
		background: #E0E7FF;
		color: #3730A3;
	}

	.input-prod-price.size-field {
		width: 72px;
		padding: 4px 6px;
		font-size: 12px;
	}

	.btn-toggle-sizes {
		background: #F1F5F9;
		border: 1px solid #CBD5E1;
		color: #475569;
		font-size: 11px;
		font-weight: 700;
		padding: 4px 8px;
		border-radius: 6px;
		cursor: pointer;
		white-space: nowrap;
		transition: all 0.15s ease;
	}

	.btn-toggle-sizes:hover {
		background: #E2E8F0;
	}

	.btn-toggle-sizes.active {
		background: #ECFDF5;
		border-color: #A7F3D0;
		color: #065F46;
	}
</style>
